module.exports = __webpack_public_path__ + "media/favicon/android-chrome-192x192-ea50b43a.png";